import React, { useState, useEffect } from 'react';
import { bool, object, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage, intlShape } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';
import getCountryCodes from '../../../translations/countryCodes';
import { IoIosRadioButtonOn } from 'react-icons/io';
import { IoIosRadioButtonOff } from 'react-icons/io';
import { MdOutlineEdit } from 'react-icons/md';
import { MdDeleteForever } from 'react-icons/md';
import {
  Button,
  FieldCheckbox,
  FieldLocationAutocompleteInput,
  FieldRadioButton,
  FieldSelect,
  FieldTextInput,
  Heading,
  IconSpinner,
  Modal,
  PrimaryButton,
} from '../../../components';

import css from './ShippingDetails.module.css';
import { batch, useDispatch, useSelector } from 'react-redux';
import { getShippingDetailsForSave } from '../CheckoutPageTransactionHelpers';
import { deleteAddressFromProfile, saveShippingAddressInProfile } from '../../../ducks/user.duck';
import FieldPhoneInput from '../../../components/FieldPhoneInput/FieldPhoneInput';
import { errors } from 'jose';
const identity = v => v;
const ShippingDetails = props => {
  const { rootClassName, className, locale, intl, disabled, formApi, fieldId, values, meta } = props;


  const [isOpen, setOpen] = useState(false);
  const [notLocationAndManualAddress, setNotLocationAndManualAddress] = useState(false);
  console.log("notLocationAndManualAddress-----", notLocationAndManualAddress)
  const [showManualAddress, setShowManualAddress] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const state = useSelector(state => state);
  const [, forceUpdate] = React.useReducer(x => x + 1, 0);
  const { currentUser, deleteAddressInProgress, deleteAddressError } = state.user;
  const { attributes } = currentUser || {};
  const { profile } = attributes || {};
  const { publicData } = profile || {};
  const { shippingAddress = [] } = publicData || {};
  const optionalText = intl.formatMessage({
    id: 'ShippingDetails.optionalText',
  });

  const setManualAddress = () => {

    setShowManualAddress(true)


  }
  useEffect(() => {
    if (values?.location?.selectedPlace || showManualAddress) {
      setNotLocationAndManualAddress(false)
    }

  }, [values?.location?.selectedPlace, showManualAddress])
  useEffect(() => {
    if (values?.location && (values.isNew || isOpen)) {
      formApi.change(
        'recipientAddressLine1',
        values?.location?.route || values.location?.selectedPlace?.address
      );
      formApi.change('recipientCity', values.location?.city);
      formApi.change('recipientPostal', values.location?.postalCode);
    }
  }, [values?.location, values.isNew, isOpen]);
  useEffect(() => {
    if (shippingAddress?.length > 0) {
      // Restore last selected address index from sessionStorage, default to 0
      const savedIndex = parseInt(sessionStorage.getItem('selectedShippingAddressIndex') || '0', 10);
      const selectedIndex = savedIndex < shippingAddress.length ? savedIndex : 0;
      const address = shippingAddress[selectedIndex];
      formApi.batch(() => {
        formApi.change('recipientName', address.name);
        formApi.change('recipientSurname', address.surname);
        formApi.change('recipientPhoneNumber', address.phoneNumber);
        formApi.change('recipientAddressLine1', address?.line1);
        formApi.change('location', address.location);
        formApi.change('recipientAddressLine2', address.line2);
        formApi.change('recipientPostal', address.postalCode);
        formApi.change('recipientCity', address.city);
        formApi.change('recipientState', address.state);
        formApi.change('recipientCountry', address.country);
        formApi.change('index', selectedIndex);
        formApi.change('isNew', undefined);
      });
    } else {
      formApi.batch(() => {
        formApi.change('isNew', true);
        formApi.change('recipientCountry', undefined);
      });
    }
  }, []);

  // Ref to suppress country-change reset during programmatic address loads
  const isLoadingSavedAddress = React.useRef(true);
  const [prevCountry, setPrevCountry] = useState(values?.recipientCountry || null);
  useEffect(() => {
    const currentCountry = values?.recipientCountry;
    if (currentCountry && currentCountry !== prevCountry) {
      setPrevCountry(currentCountry);
      if (isLoadingSavedAddress.current) {
        // Skip reset when address is loaded programmatically (saved address / initial load)
        isLoadingSavedAddress.current = false;
        return;
      }
      formApi.batch(() => {
        formApi.change('recipientAddressLine1', undefined);
        formApi.change('recipientAddressLine2', undefined);
        formApi.change('recipientPostal', undefined);
        formApi.change('recipientCity', undefined);
        formApi.change('recipientState', undefined);
        formApi.change('recipientPhoneNumber', undefined);
        formApi.change('location', undefined);
      });
      setShowManualAddress(false);
    }
  }, [values?.recipientCountry]);



  useEffect(() => {
    if (!(values.isNew || isOpen)) return;
    const { city, postalCode, region, route, search } = values.location || {};

    formApi.change('recipientAddressLine1', route?.split(' ')
      .filter(word => word !== 'undefined')
      .join(' ')
      .trim() || search?.split(' ')
        .filter(word => word !== 'undefined')
        .join(' ')
        .trim());

    formApi.change('recipientPostal', postalCode);
    formApi.change('recipientCity', city);
  }, [values.location, values.isNew, isOpen]);


  const dispatch = useDispatch();
  const classes = classNames(rootClassName || css.root, className);
  const handleDeleteAddress = async index => {
    try {
      await dispatch(deleteAddressFromProfile(index));
      if (values?.index === index) {
        sessionStorage.removeItem('selectedShippingAddressIndex');
        formApi.batch(() => {
          formApi.change('isNew', true);
          formApi.change('recipientName', undefined);
          formApi.change('recipientSurname', undefined);
          formApi.change('recipientPhoneNumber', undefined);
          formApi.change('recipientAddressLine1', undefined);
          formApi.change('recipientAddressLine2', undefined);
          formApi.change('recipientPostal', undefined);
          formApi.change('location', undefined);
          formApi.change('recipientCity', undefined);
          formApi.change('recipientState', undefined);
          formApi.change('recipientCountry', undefined);
          formApi.change('index', undefined);
        });
      } else if (values?.index > index) {
        const newIndex = values.index - 1;
        sessionStorage.setItem('selectedShippingAddressIndex', newIndex.toString());
        formApi.change('index', newIndex);
      }
    } catch (e) {
      console.error('Failed to delete address:', e);
    }
  };
  const handleSubmit = async () => {
    setIsLoading(true);
    const shippingData = getShippingDetailsForSave(values);
    console.log(shippingData, 'shippingData>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    let newAddresses;
    let newIndex;
    if (shippingData && shippingData?.isNew) {
      newAddresses = [...shippingAddress, shippingData];
      newIndex = newAddresses.length - 1;
    } else if (shippingData) {
      const newAddress = [...shippingAddress];
      newAddress[(shippingData?.index)] = shippingData;
      newAddresses = newAddress;
      newIndex = shippingData?.index;
    }
    if (newAddresses) {
      try {
        await dispatch(saveShippingAddressInProfile(newAddresses));
        setIsLoading(false);
        setOpen(false);
        formApi.batch(() => {
          formApi.change('isNew', undefined);
          formApi.change('index', newIndex); // Set the new address as the selected address
        });
        forceUpdate(); // Rerender the component
      } catch (error) {
        console.error('Failed to save shipping address:', error);
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const handleSubmitWithValidation = async () => {
    const requiredFields = [
      'recipientName',
      'recipientSurname',
      'recipientAddressLine1',
      'recipientCity',
      'recipientPostal',
      'recipientPhoneNumber',
    ];

    if (!values?.location?.selectedPlace && !showManualAddress) {
      setNotLocationAndManualAddress(true)
      // setManualAddress()


    }

    const missingFields = requiredFields.filter(field => !values[field]);

    if (missingFields.length > 0) {
      missingFields.forEach(field => {
        formApi.blur(field);
      });
      return;
    }

    // Also check for validation errors on required fields
    const formState = formApi.getState();
    const fieldErrors = formState?.errors || {};
    const fieldsWithErrors = requiredFields.filter(field => fieldErrors[field]);
    if (fieldsWithErrors.length > 0) {
      fieldsWithErrors.forEach(field => {
        formApi.blur(field);
      });
      return;
    }

    await handleSubmit();
  };

  const areAllValuesPresent = () => {
    const requiredFields = [
      'recipientName',
      'recipientSurname',
      'recipientAddressLine1',
      'recipientCity',
      'recipientPostal',
      'recipientPhoneNumber',
    ];
    return requiredFields.every(field => values[field]);
  };
  const countryCodes = getCountryCodes(intl.locale);

  // EU country codes (ISO 3166-1 alpha-2)
  const euCountryCodes = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
    'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  ];

  // Build shipping countries: Greece first, Cyprus second, then remaining EU countries alphabetically
  const getShippingCountryCodes = () => {
    const greece = countryCodes.find(c => c.code === 'GR');
    const cyprus = countryCodes.find(c => c.code === 'CY');
    const remainingEU = countryCodes
      .filter(c => euCountryCodes.includes(c.code) && c.code !== 'GR' && c.code !== 'CY')
      .sort((a, b) => a.name.localeCompare(b.name));
    return [greece, cyprus, ...remainingEU].filter(Boolean);
  };

  const shippingCountryCodes = getShippingCountryCodes();
  const shippingDetailForm =
    values?.isNew || isOpen ? (
      <div style={{ margin: '1rem' }}>
        <FieldTextInput
          id={`${fieldId}.recipientName`}
          name="recipientName"
          disabled={disabled}
          className={css.fieldFullWidth}
          type="text"
          autoComplete="shipping name"
          label={intl.formatMessage({ id: 'ShippingDetails.recipientNameLabel' })}
          placeholder={intl.formatMessage({
            id: 'ShippingDetails.recipientNamePlaceholder',
          })}
          validate={validators.required(
            intl.formatMessage({ id: 'ShippingDetails.recipientNameRequired' })
          )}
        // onUnmount={() => formApi.change('recipientName', undefined)}
        />
        <FieldTextInput
          id={`${fieldId}.recipientSurname`}
          name="recipientSurname"
          disabled={disabled}
          className={css.fieldFullWidth}
          type="text"
          label={intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.surnameLabel' })}
          placeholder={intl.formatMessage({
            id: 'ShippingDetails.ShippingDetails.surnamePlaceholder',
          })}
          validate={validators.required(
            intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.surnameRequired' })
          )}
        // onUnmount={() => formApi.change('recipientSurname', undefined)}
        />
        <FieldSelect
          id={`${fieldId}.recipientCountry`}
          name="recipientCountry"
          disabled={disabled}
          className={css.fieldFullWidth}
          label={intl.formatMessage({ id: 'ShippingDetails.countryLabel' })}
          validate={validators.required(
            intl.formatMessage({ id: 'ShippingDetails.countryRequired' })
          )}
        >
          <option disabled value="">
            {intl.formatMessage({ id: 'ShippingDetails.countryPlaceholder' })}
          </option>
          {shippingCountryCodes.map(country => {
            return (
              <option key={country.code} value={country.code}>
                {country.name}
              </option>
            );
          })}
        </FieldSelect>

        <>
          <FieldLocationAutocompleteInput
            rootClassName={css.fieldFullWidth}
            setManualAddress={setManualAddress}
            fromAddresssPopUp={true}
            inputClassName={css.locationAutocompleteInput}
            iconClassName={css.locationAutocompleteInputIcon}
            predictionsClassName={css.predictionsRoot}
            validClassName={css.validLocation}
            countryLimit={values.recipientCountry ? [values.recipientCountry] : []}
            id={`${fieldId}.location`}
            name="location"
            label={intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.addressLabel' })}
            placeholder={intl.formatMessage({
              id: 'ShippingDetails.addressLine1Placeholder',
            })}
            useDefaultPredictions={false}
            format={identity}
          />

          {notLocationAndManualAddress && <div className={css.customError}><FormattedMessage id="ShippingForm.AddressNotPresentCustomError" /></div>}
          {/* <p className={css.tip}>
            {intl.formatMessage(
              { id: 'ShippingDetails.ShippingDetails.tip' },
              {
                option: (
                  <span
                    className={css.addManual}
                    onClick={() => setShowManualAddress(!showManualAddress)}
                  >
                    {intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.addmanually' })}
                  </span>
                ),
              }
            )}
          </p> */}
        </>
        {values?.location?.selectedPlace || showManualAddress ? (
          <div>
            <FieldTextInput
              id={`${fieldId}.recipientAddressLine1`}
              name="recipientAddressLine1"
              disabled={disabled}
              className={css.fieldFullWidth}
              type="text"
              autoComplete="shipping address-line1"
              label={intl.formatMessage({ id: 'ShippingDetails.addressLine1Label' })}
              placeholder={intl.formatMessage({
                id: 'ShippingDetails.addressLine1Placeholder',
              })}
              validate={validators.required(
                intl.formatMessage({ id: 'ShippingDetails.addressLine1Required' })
              )}
            // onUnmount={() => formApi.change('recipientAddressLine1', undefined)}
            />
            <FieldTextInput
              id={`${fieldId}.recipientAddressLine2`}
              name="recipientAddressLine2"
              disabled={disabled}
              className={css.fieldFullWidth}
              type="text"
              autoComplete="shipping address-line2"
              label={intl.formatMessage(
                { id: 'ShippingDetails.addressLine2Label' },
                { optionalText: optionalText }
              )}
              placeholder={intl.formatMessage({
                id: 'ShippingDetails.addressLine2Placeholder',
              })}
            // onUnmount={() => formApi.change('recipientAddressLine2', undefined)}
            />
            {/* <FieldTextInput
              id={`${fieldId}.recipientAddressLine2`}
              name="recipientAddressLine2"
              disabled={disabled}
              className={css.fieldFullWidth}
              type="text"
              autoComplete="shipping address-line2"
              label={intl.formatMessage(
                { id: 'ShippingDetails.addressLine2Label' },
                { optionalText: optionalText }
              )}
              placeholder={intl.formatMessage({
                id: 'ShippingDetails.addressLine2Placeholder',
              })}
              // onUnmount={() => formApi.change('recipientAddressLine2', undefined)}
            /> */}
            <div className={css.formRow}>
              <FieldTextInput
                id={`${fieldId}.recipientPostalCode`}
                name="recipientPostal"
                disabled={disabled}
                className={css.field}
                type="text"
                autoComplete="shipping postal-code"
                label={intl.formatMessage({ id: 'ShippingDetails.postalCodeLabel' })}
                placeholder={intl.formatMessage({
                  id: 'ShippingDetails.postalCodePlaceholder',
                })}
                validate={validators.required(
                  intl.formatMessage({ id: 'ShippingDetails.postalCodeRequired' })
                )}
              // onUnmount={() => formApi.change('recipientPostal', undefined)}
              />

              <FieldTextInput
                id={`${fieldId}.recipientCity`}
                name="recipientCity"
                disabled={disabled}
                className={css.field}
                type="text"
                autoComplete="shipping address-level2"
                label={intl.formatMessage({ id: 'ShippingDetails.cityLabel' })}
                placeholder={intl.formatMessage({ id: 'ShippingDetails.cityPlaceholder' })}
                validate={validators.required(
                  intl.formatMessage({ id: 'ShippingDetails.cityRequired' })
                )}
              // onUnmount={() => formApi.change('recipientCity', undefined)}
              />
            </div>
          </div>
        ) : null}
        <FieldPhoneInput
          id={`${fieldId}.recipientPhoneNumber`}
          name="recipientPhoneNumber"
          disabled={disabled}
          className={css.fieldFullWidth}
          type="text"
          defaultCountry={values.recipientCountry || undefined}
          label={intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.phoneNumber' })}
          placeholder={intl.formatMessage({
            id: 'ShippingDetails.recipientPhoneNumberPlaceholder',
          })}
          validate={validators.composeValidators(
            validators.required(
              intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.phoneNumberRequired' })
            ),
            validators.validatePhoneNumber(
              intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.phoneNumberValid' })
            )
          )}
        // onUnmount={() => formApi.change('recipientPhoneNumber', undefined)}
        />
        <FieldCheckbox
          className={css.newsletter}
          id="viber"
          name="viber"
          label={
            <span className={css.newsletterText}>
              {intl.formatMessage({
                id: 'ContactDetailsForm.ContactDetailsForm.viberText',
              })}
            </span>
          }
        />
      </div>
    ) : null;
  return (
    <div className={classes}>
      <Heading as="h3" rootClassName={css.heading}>
        <FormattedMessage id="ShippingDetails.title" />
      </Heading>
      {deleteAddressError ? (
        <p className={css.error}>
          {deleteAddressError?.message || 'An error occured while deleting the address'}
        </p>
      ) : null}
      {shippingAddress?.map((address, index) => {
        return (
          <div>
            <div className={css.addressContainer}>
              <div
                className={css.leftContainer}
                onClick={() => {
                  setOpen(false);
                  if (values?.index === index) {
                    // Already selected — do nothing (prevent unchecking)
                    return;
                  } else {
                    sessionStorage.setItem('selectedShippingAddressIndex', index.toString());
                    isLoadingSavedAddress.current = true;
                    formApi.batch(() => {
                      formApi.change('recipientName', address.name);
                      formApi.change('recipientSurname', address.surname);
                      formApi.change('recipientPhoneNumber', address.phoneNumber);
                      formApi.change('recipientAddressLine1', address?.line1);
                      formApi.change('recipientAddressLine2', address.line2);
                      formApi.change('recipientPostal', address.postalCode);
                      formApi.change('location', address.location);
                      formApi.change('recipientCity', address.city);
                      formApi.change('recipientState', address.state);
                      formApi.change('recipientCountry', address.country);
                      formApi.change('index', index);
                      formApi.change('isNew', undefined);
                    });
                  }
                }}
              >
                <div className={css.iconContainer}>
                  {values?.index === index ? (
                    <IoIosRadioButtonOn size={20} color={'#333333'} />
                  ) : (
                    <IoIosRadioButtonOff size={20} color={'#333333'} />
                  )}
                </div>
                <div className={css.dataContainer}>
                  <div className={css.name}>
                    {address.name} {address?.surname}
                  </div>
                  <div className={css.address}>{address?.line1}</div>
                  <div className={css.address}>{address?.line2}</div>
                  <div className={css.city}>{address.city}</div>
                  <div className={css.city}>{address.postalCode}</div>
                  <div className={css.country}>
                    {countryCodes?.find(country => {
                      return country.code === address.country;
                    })?.name || address.country}
                  </div>
                  <div className={css.phone}>{address.phoneNumber}</div>
                </div>
              </div>
              <div className={css.editContainer}>
                <MdOutlineEdit
                  className={css.icon}
                  size={20}
                  color={'#333333'}
                  onClick={() => {
                    // console.log('hit address', address);
                    isLoadingSavedAddress.current = true;
                    formApi.batch(() => {
                      formApi.change('recipientName', address.name);
                      formApi.change('recipientSurname', address.surname);
                      formApi.change('recipientPhoneNumber', address.phoneNumber);
                      formApi.change('location', address.location);
                      formApi.change('recipientAddressLine1', address.line1);
                      formApi.change('recipientAddressLine2', address.line2);
                      formApi.change('recipientPostal', address.postalCode);
                      formApi.change('recipientCity', address.city);
                      formApi.change('recipientState', address.state);
                      formApi.change('recipientCountry', address.country);
                      formApi.change('index', index);
                      formApi.change('isNew', undefined);
                    });
                    setOpen(true);
                  }}
                />
                {deleteAddressInProgress?.loading &&
                  deleteAddressInProgress?.addressId === index ? (
                  <IconSpinner className={css.deleteIcon} size={20} />
                ) : (
                  <MdDeleteForever
                    className={css.deleteIcon}
                    size={20}
                    color={'#333333'}
                    onClick={() => {
                      handleDeleteAddress(index);
                    }}
                  />
                )}
              </div>
            </div>
            {values?.index === index ? <div>{shippingDetailForm}</div> : null}
            {values?.index === index && isOpen ? (
              <Button
                type="button"
                onClick={handleSubmitWithValidation}
                disabled={isLoading} // Keep this disabled only for loading state
              >
                {isLoading ? (
                  <IconSpinner />
                ) : (
                  <FormattedMessage id="ShippingDetails.submitButton" defaultMessage="Submit" />
                )}
              </Button>
            ) : null}
          </div>
        );
      })}

      <div className={css.newAddress}>
        <div className={css.addressContainerNew}>
          <div
            className={css.leftContainer}
            onClick={() => {
              setOpen(true);
              if (values?.isNew) {
                // Already selected — do nothing (prevent unchecking)
                return;
              } else {
                formApi.batch(() => {
                  formApi.change('isNew', true);
                  formApi.change('recipientName', values?.name);
                  formApi.change('recipientSurname', values?.recipientSurname);
                  formApi.change('recipientPhoneNumber', undefined);
                  formApi.change('recipientAddressLine1', undefined);
                  formApi.change('recipientAddressLine2', undefined);
                  formApi.change('recipientPostal', undefined);
                  formApi.change('location', undefined);
                  formApi.change('recipientCity', undefined);
                  formApi.change('recipientState', undefined);
                  formApi.change('recipientCountry', undefined);
                  formApi.change('index', undefined);
                });
              }
            }}
          >
            <div className={css.iconContainer}>
              {values?.isNew ? (
                <IoIosRadioButtonOn size={20} color={'#333333'} />
              ) : (
                <IoIosRadioButtonOff size={20} color={'#333333'} />
              )}
            </div>
            <div className={css.dataContainer}>
              {intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.addNewAddress' })}
            </div>
          </div>
        </div>
        {values?.isNew ? <div>{shippingDetailForm}</div> : null}
      </div>

      {/* {values?.isNew || isOpen ? (
        <div style={{ margin: '1rem' }}>
          <FieldTextInput
            id={`${fieldId}.recipientName`}
            name="recipientName"
            disabled={disabled}
            className={css.fieldFullWidth}
            type="text"
            autoComplete="shipping name"
            label={intl.formatMessage({ id: 'ShippingDetails.recipientNameLabel' })}
            placeholder={intl.formatMessage({
              id: 'ShippingDetails.recipientNamePlaceholder',
            })}
            validate={validators.required(
              intl.formatMessage({ id: 'ShippingDetails.recipientNameRequired' })
            )}
            onUnmount={() => formApi.change('recipientName', undefined)}
          />
          <FieldTextInput
            id={`${fieldId}.recipientSurname`}
            name="recipientSurname"
            disabled={disabled}
            className={css.fieldFullWidth}
            type="text"
            label={intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.surnameLabel' })}
            placeholder={intl.formatMessage({
              id: 'ShippingDetails.ShippingDetails.surnamePlaceholder',
            })}
            validate={validators.required(
              intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.surnameRequired' })
            )}
            onUnmount={() => formApi.change('recipientSurname', undefined)}
          />
          <FieldSelect
            id={`${fieldId}.recipientCountry`}
            name="recipientCountry"
            disabled={disabled}
            className={css.fieldFullWidth}
            label={intl.formatMessage({ id: 'ShippingDetails.countryLabel' })}
            validate={validators.required(
              intl.formatMessage({ id: 'ShippingDetails.countryRequired' })
            )}
          >
            <option disabled value="">
              {intl.formatMessage({ id: 'ShippingDetails.countryPlaceholder' })}
            </option>
            {shippingCountryCodes.map(country => {
              return (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              );
            })}
          </FieldSelect>
          <>
            <FieldLocationAutocompleteInput
              rootClassName={css.fieldFullWidth}
              inputClassName={css.locationAutocompleteInput}
              iconClassName={css.locationAutocompleteInputIcon}
              predictionsClassName={css.predictionsRoot}
              validClassName={css.validLocation}
              countryLimit={values.recipientCountry ? [values.recipientCountry] : []}
              id={`${fieldId}.location`}
              name="location"
              label={intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.addressLabel' })}
              placeholder={intl.formatMessage({
                id: 'ShippingDetails.addressLine1Placeholder',
              })}
              useDefaultPredictions={false}
              format={identity}
            />
            <p className={css.tip}>
              {intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.tip' })}
            </p>
          </>

          <FieldTextInput
            id={`${fieldId}.recipientAddressLine1`}
            name="recipientAddressLine1"
            disabled={disabled}
            className={css.fieldFullWidth}
            type="text"
            autoComplete="shipping address-line1"
            label={intl.formatMessage({ id: 'ShippingDetails.addressLine1Label' })}
            placeholder={intl.formatMessage({
              id: 'ShippingDetails.addressLine1Placeholder',
            })}
            validate={validators.required(
              intl.formatMessage({ id: 'ShippingDetails.addressLine1Required' })
            )}
            onUnmount={() => formApi.change('recipientAddressLine1', undefined)}
          />
          <FieldTextInput
            id={`${fieldId}.recipientAddressLine2`}
            name="recipientAddressLine2"
            disabled={disabled}
            className={css.fieldFullWidth}
            type="text"
            autoComplete="shipping address-line2"
            label={intl.formatMessage(
              { id: 'ShippingDetails.addressLine2Label' },
              { optionalText: optionalText }
            )}
            placeholder={intl.formatMessage({
              id: 'ShippingDetails.addressLine2Placeholder',
            })}
            onUnmount={() => formApi.change('recipientAddressLine2', undefined)}
          />
          <div className={css.formRow}>
            <FieldTextInput
              id={`${fieldId}.recipientPostalCode`}
              name="recipientPostal"
              disabled={disabled}
              className={css.field}
              type="text"
              autoComplete="shipping postal-code"
              label={intl.formatMessage({ id: 'ShippingDetails.postalCodeLabel' })}
              placeholder={intl.formatMessage({
                id: 'ShippingDetails.postalCodePlaceholder',
              })}
              validate={validators.required(
                intl.formatMessage({ id: 'ShippingDetails.postalCodeRequired' })
              )}
              onUnmount={() => formApi.change('recipientPostal', undefined)}
            />

            <FieldTextInput
              id={`${fieldId}.recipientCity`}
              name="recipientCity"
              disabled={disabled}
              className={css.field}
              type="text"
              autoComplete="shipping address-level2"
              label={intl.formatMessage({ id: 'ShippingDetails.cityLabel' })}
              placeholder={intl.formatMessage({ id: 'ShippingDetails.cityPlaceholder' })}
              validate={validators.required(
                intl.formatMessage({ id: 'ShippingDetails.cityRequired' })
              )}
              onUnmount={() => formApi.change('recipientCity', undefined)}
            />
          </div>
          <FieldPhoneInput
            id={`${fieldId}.recipientPhoneNumber`}
            name="recipientPhoneNumber"
            disabled={disabled}
            className={css.fieldFullWidth}
            type="text"
            defaultCountry={values.recipientCountry || undefined}
            label={intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.phoneNumber' })}
            placeholder={intl.formatMessage({
              id: 'ShippingDetails.recipientPhoneNumberPlaceholder',
            })}
            validate={validators.composeValidators(
              validators.required(
                intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.phoneNumberRequired' })
              ),
              validators.validatePhoneNumber(
                intl.formatMessage({ id: 'ShippingDetails.ShippingDetails.phoneNumberValid' })
              )
            )}
            onUnmount={() => formApi.change('recipientPhoneNumber', undefined)}
          />
        </div>
      ) : null} */}
      {values?.isNew ? (
        <Button
          type="button"
          onClick={handleSubmitWithValidation}
          disabled={isLoading} // Keep this disabled only for loading state
        >
          {isLoading ? (
            <IconSpinner />
          ) : (
            <FormattedMessage id="ShippingDetails.submitButton" defaultMessage="Submit" />
          )}
        </Button>
      ) : null}
    </div>
  );
};

ShippingDetails.defaultProps = {
  rootClassName: null,
  className: null,
  disabled: false,
  fieldId: null,
};

ShippingDetails.propTypes = {
  rootClassName: string,
  className: string,
  disabled: bool,
  formApi: object.isRequired,
  fieldId: string,

  // from injectIntl
  intl: intlShape.isRequired,
};

export default ShippingDetails;
